export var URL;
(function (URL) {
    URL["AppStore"] = "https://wagwalking.app.link/Bf3eCbCWT5";
    URL["PlayStore"] = "https://wagwalking.app.link/BJ89B4xWT5";
    URL["AppStorePremium"] = "https://wagwalking.app.link/SUlxUmIVaeb";
})(URL || (URL = {}));
